import styled from 'styled-components';
import { Audience } from '@/features/dashboard/audiences/models';
import { MetricKind } from '@/webapi/models';

export function getRawMetric(audience: Audience, kind: MetricKind): number {
  return audience?.metrics?.find((x) => x.name === kind)?.value || 0;
}

export function formatPercentageOfTotal(value: number, total: number): string {
  if (total === 0) return `0`;
  return ((value / total) * 100).toFixed(1);
}

export function formatDifference(
  value: number,
  total: number,
  isPercentagePoints: boolean,
): string {
  if (isPercentagePoints) {
    // For CR: difference in percentage points
    const diff = value * 100 - total * 100;
    const sign = diff >= 0 ? `+` : ``;
    return `${sign}${diff.toFixed(1)}`;
  }
  // For AOV: percentage difference
  if (total === 0) return `0`;
  const percentDiff = ((value - total) / total) * 100;
  const sign = percentDiff >= 0 ? `+` : ``;
  return `${sign}${percentDiff.toFixed(1)}`;
}

export const MetricPercentage = styled.span<{ invisible?: boolean }>`
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  color: #8a9ba8;
  text-align: start;
  margin-top: 0.3rem;
  opacity: ${(p) => (p.invisible ? 0 : 1)};
`;

export const ALL_VISITORS_NAME = `All Visitors`;
